import React from 'react';
import { Amplify } from 'aws-amplify';

import { AppRoutes } from './routes';
import awsconfig from './config/aws';
import setupAxiosInterceptors from './interceptors/axiosInterceptor';

setupAxiosInterceptors();

const App = () => {
  Amplify.configure(awsconfig);

  return <AppRoutes />;
};

export default App;
